
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ambassadors",
      function () {
        return require("private-next-pages/ambassadors.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ambassadors"])
      });
    }
  